<button mat-flat-button color="primary" (click)="adding_year()" class="search-btn">
    Add year
</button>

<div *ngIf="is_list_visible">
    <mat-card>
      <mat-card-title class="title-center">year List</mat-card-title>
    
      <div class="outer-scroll-wrapper">
        <div class="inner-scroll-container mat-elevation-z8">
          <table mat-table [dataSource]="years" class="full-width-table">
    
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> Actions </th>
              <td mat-cell *matCellDef="let year">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon><b>⋮</b></mat-icon>
                </button>
            
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="change_status(year.id)">
                        <mat-icon>{{ year.is_active ? 'cancel' : 'check_circle' }}</mat-icon>
                        <span>{{ year.is_active ? 'Deactivate' : 'Activate' }}</span>
                    </button>
                </mat-menu>
              </td>
            </ng-container>
            
            
            
    
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef> S.No. </th>
              <td mat-cell *matCellDef="let row; let i = index">
                {{ currentPage + i + 1 }}
              </td>
            </ng-container>
    
            <!-- Define columns -->
            <ng-container matColumnDef="year_name">
              <th mat-header-cell *matHeaderCellDef> year Name </th>
              <td mat-cell *matCellDef="let s"> {{ s.year_name }} </td>
            </ng-container>
  
            <ng-container matColumnDef="is_active">
              <th mat-header-cell *matHeaderCellDef> Active status </th>
              <td mat-cell *matCellDef="let s">
                <mat-icon color="{{ s.is_active ? 'primary' : 'warn' }}">
                  {{ s.is_active ? 'check_circle' : 'cancel' }}
                </mat-icon>
              </td>
            </ng-container>
    
            <!-- Header and Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
    </mat-card>
</div>

<div *ngIf="add_form">
    <div class="container-fluid">
      <div class="row g-4">
        <div class="col-12">
          <mat-card>
            <mat-card-content>
              <div>
                <form [formGroup]="formGroup">
                  <!-- Contact Information Section -->
                  <div class="row g-4 mt-3">
                    <div class="col-12">
                      <h6 class="section-title">Year Add</h6>
                    </div>
  
                    <div class="col-md-6">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-label>enter year :</mat-label>
                        <input matInput formControlName="year_name" placeholder="Enter year" type="number">
                      </mat-form-field>
                    </div>
  
                    <div class="row mt-4">
                      <div class="col-12">
                        <div class="d-flex gap-3">
                          <button mat-flat-button color="primary" [disabled]="isLoading" (click)="add_year()" class="px-4 py-2">
                            ADD
                          </button>
                          <button mat-stroked-button [disabled]="isLoading" (click)="resetForm()" class="px-4 py-2">
                            RESET
                          </button>
                          <button *ngIf="isEdit || !isCourseList" mat-flat-button color="primary" (click)="back()" class="px-4 py-2">
                            Back
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
</div>
  